// Import controller interfaces
import {
    IEndorsementMortgageeController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    MortgageeRequest,
    MortgageeRequestWithId,
} from '@app/models/api';

export default class MockEndorsementMortgageeController implements IEndorsementMortgageeController {

    public constructor() {

    }

    public async updateMortgagees(policyId: number, zipCode: string, mortgageesToAdd: MortgageeRequest[], mortgageesToUpdate: MortgageeRequestWithId[], mortgageesToDelete: string[]): Promise<{ policyId: number; message: string; }> {
        throw new Error('Method not implemented.');
    }
};